export default async callback =>
  new Promise(resolve => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(time => {
        resolve(callback(time));
      });
    });
  });
